import { compose, withHandlers, withProps } from 'recompose';
import {
  loadState,
  removeState,
  saveState,
  START_PROJECT_PRODUCT_ATTRIBUTES,
  START_PROJECT_VOUCHER_CODE,
} from '../../Common/localStorage';

export const withStartProjectState = compose(
  withProps(() => ({
    startProjectVoucherCode: loadState(START_PROJECT_VOUCHER_CODE),
    startProjectProductAttributes: loadState(START_PROJECT_PRODUCT_ATTRIBUTES) || {},
  })),
  withHandlers({
    saveVoucherCode: () => voucherCode => saveState(START_PROJECT_VOUCHER_CODE, voucherCode),
    saveProductAttributes: () => attributes =>
      saveState(START_PROJECT_PRODUCT_ATTRIBUTES, attributes),
    removeVoucherCode: () => () => removeState(START_PROJECT_VOUCHER_CODE),
    removeProductAttributes: () => () => removeState(START_PROJECT_PRODUCT_ATTRIBUTES),
  }),
);



// WEBPACK FOOTER //
// ./src/Account/Voucher/withStartProject.js